export default {
  hostProfiles: ({ showId }) => ['show', showId, 'profiles', 'hosts'],
  hostProfile: ({ showId, profileId }) => ['show', showId, 'hosts', 'profile', profileId],
};
